import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Input } from "sr/helpers";
import { fetchBalance } from "sr/helpers/apiFunctions/fetchBalance";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { WarningRed } from "sr/helpers/ui-components/company/WarningRed";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { getKycDetails } from "sr/utils/api/cleaner/kyc/getKycDetails";
import { createPayment } from "sr/utils/api/cleaner/trolley/createPayment";
import { getRecipient } from "sr/utils/api/cleaner/trolley/getRecipient";
import { getTransaction } from "sr/utils/api/wallet/getTransaction";
import { Pagination } from "app/pages/component/Pagination";
import { DeleteConfirmation } from "app/pages/component/DeleteConfirmation";
import { ModelWrapper } from "app/pages/individual/component/ModelWrapper";
import { TableRow } from "./balance/TableRow";
import { removePaymentBatch } from "sr/utils/api/cleaner/trolley/removePaymentBatch";
export const Balance = () => {
  const [balance, setBalance] = useState(null)
  const [userId, setUserId] = useState<string>('')
  const [history, setHistory] = useState(null)
  const [loader, setLoader] = useState(true)
  const [recipientDetails, setRecipientDetails] = useState(null)
  const [loader1, setLoader1] = useState(false)
  const [amount, setAmount] = useState(null)
  const [kycCompleted, setKycCompleted] = useState(false)
  const [accountsAdded, setAccountsAdded] = useState(false)
  const [withdrawClicked, setWithdrawClicked] = useState(false)
         const [totalPage, settotalPage] = useState<number>(1);
         const [page, setPage] = useState(1)
         const [limit, setLimit] = useState(10)
 const [showDelete, setShowDelete] = useState(false)
 const [deleteId, setDeleteId] = useState<string>('')
         useEffect(()=>{
      const {user_id} = getUserDetails()
      if(user_id) {

        
      setUserId(user_id)
      }
  },[])
  const fetchKycDetails = async ()=>{
    try {
const queryParams = new URLSearchParams()
queryParams.append('user_id', userId)
const res = await getKycDetails(queryParams)

if(res?.success===true){

  
  if(res?.data?.status==='completed'){
    setKycCompleted(true)
  }
}
    }
    catch(e){

    }
  }
  
  useEffect(()=>{
    if(userId){
      fetchKycDetails()
      fetchRecipient()
      
    }
  },[userId])
  useEffect(()=>{
      if(userId){
        fetchBalance({userId:userId, setData:setBalance, setLoader:setLoader})
      }
  },[userId])
    const fetchRecipient = async ()=>{
      setLoader1(true)
      try {
      const queryParams = new URLSearchParams()
      if (userId) queryParams.append('user_id', userId)
        const res = await getRecipient(queryParams)
      if(res?.success===true){
        setRecipientDetails(res?.data)
        setAccountsAdded(res?.data?.accounts?.some((item)=> item?.status==='primary'))
        setLoader1(false)
        
      }
      else{
        setLoader1(false)
      }
    }
    catch(e){
        setLoader1(false)
    }
    }
    const handlePayment = async ()=>{
      // Harendra open this block
      // if(parseFloat(amount) > parseFloat(balance?.available_balance)){
      //   toast.error("Insufficient funds")
      //   return
      // }
      setLoader1(true)
      const payload = {
        user_id:userId,
        sourceAmount:amount,
        recipient:{email:recipientDetails?.email}
      }
        try {
            const res = await createPayment(payload)
            if(res?.success===true){
                setLoader1(false)
                if(res?.data?.status==='open'){
                toast.success("Payment Request Submitted Successfully ")
                setWithdrawClicked(false)
                    fetchTransaction()
                }
            }
            else {
                setLoader1(false)
            }
        }
        catch(e){
              setLoader1(false)
        }
    }
    useEffect(()=>{

    },[withdrawClicked])
      const fetchTransaction = async ()=> {
        setLoader(true)
            const queryParams = new URLSearchParams()
            const filterarr = []
                  queryParams.append('from', userId)    
                  queryParams.append('status', 'pending')
                  queryParams.append('batch_id!', '')
                  queryParams.append('page', page?.toString())
                  queryParams.append('limit', limit?.toString())
                    const res = await getTransaction(queryParams)
                    if(res?.success===true) {
                        setLoader(false)
                        setHistory(res?.data)
                        settotalPage(Math.ceil(res?.pagination.total / limit));
                    }
                    else {
                        setLoader(true)
                    }
        }
        useEffect(()=> {
                            if(userId) {
                fetchTransaction()
                            }
                    },[userId,page, status])
                    
                    const HandleModelByProps = (data)=>{
                      setShowDelete(data)
                    }
                    const HandleDelete = async (id)=>{
                      const queryParams = new URLSearchParams()
                      queryParams.append('batch_id', id)
                        try {
                      const res = await removePaymentBatch(queryParams)
                      if(res?.success===true){
                        toast.success("Withdrawal Request cancelled")
                        setShowDelete(false)
                        setDeleteId('')
                        setHistory(history?.filter((item)=> item?.batch_id !==id))
                        fetchBalance({userId:userId, setData:setBalance, setLoader:setLoader})
                      }
                        }
                        catch(e){

                        }
                    }
  return (
    <ContentWithSpinner loader={loader} height="min-h-[50vh]">
    <div className="border border-gray-border rounded-xl w-full bg-white text-black pt-10 pb-10">
      <div className="flex">
     {loader1 && <LoaderFullScreen></LoaderFullScreen> }
    <div className="mx-auto px-3">
        <div className="text-2xl  mb-5 text-center">Available Balance</div>
        <div className="text-2xl text-center ">${Number(balance?.available_balance) ? Number(balance?.available_balance)?.toFixed(2) : '0.00'}</div>

    {
      (kycCompleted && accountsAdded) ? (<>

        {withdrawClicked ? (
  <div className="mt-10">
    <div>
      {recipientDetails?.accounts?.filter((item)=> item?.primary===true).map((item)=> (
      <div className="flex space-x-3">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-14 h-14">
  <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
</svg>
 <div className="font-bold">
  <div>{item?.accountNum}</div>
  <div>{item?.bankName}</div>
  </div>
</div>
))}
    </div>

       <Input 
       prefix="$" 
       label={'Enter Amount'}
       InputDivClass="mt-0 w-26 pr-2 pb-2 mt-6"  
      inputClass="border border-zinc-800 rounded-lg [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
       value={amount} onChange={(e)=>setAmount(e.target.value)} type="number"></Input>
       <div onClick={handlePayment} className="text-center rounded-lg bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy" >Submit</div>
    </div>
    
        )
        :<>
       { balance?.available_balance>0 &&
        <div className="text-center mt-10">
        <button onClick={()=> setWithdrawClicked(true)} className='bg-[#ff39b3] text-white hover:bg-navy p-2 w-24 rounded-3xl font-bold'>Withdraw</button>
        </div>
}
        </>
      }
    </>)
        :
   
      ( 
        <>
       { !kycCompleted && (
        <div><WarningRed paragraph="Please Complete your KYC for Wallet Withdrawals"></WarningRed></div>
      )
    }
    {
      !accountsAdded && 
      <div><WarningRed paragraph="Please add your Payment Method for Wallet Withdrawals"></WarningRed></div>
    }
        

        </> )

         }
      
    </div>
   </div>
   {history?.length>0 && 
   <div className="px-4">
   <div className="text-lg  mb-5 font-semibold"><p>Recent Requests</p></div>
    <div className="overflow-x-auto mt-4 rounded-[20px] border border-neutral-200">
    <table className="w-full text-left condidate-table">
           <thead className="bg-[#FAF9F8] border-collapse border-b border-neutral-200 capitalize">
               <tr>
               <th scope="col" className="px-6 py-4 text-base ">
     Amount
   </th>
                 
               <th scope="col" className="px-6 py-4 text-base ">
    Status
   </th>
   <th scope="col" className="px-6 py-4 text-base">
     Date and time
   </th>
   
   <th scope="col" className="px-6 py-4 text-base">
    Action
   </th>
   
               </tr>
           </thead>
           <tbody>
               {history?.map((item)=> (
   
           <TableRow key={item?.id} setShowDelete = {setShowDelete} setDeleteId={setDeleteId}  item={item}/>
     )) }
             
           </tbody>
       </table>
       {totalPage>1 &&
              <Pagination page={page} totalPage={totalPage} setPage={setPage} />
       }
       </div>
</div>
}
    {showDelete &&
    <ModelWrapper rounded="rounded-[10px]"
    background="bg-[#00000099]"
    position="fixed"
    opacity="opacity-100"
    topPosition="top-[10%]"
    rightPosition="inset-0"
    width="w-[50%] mx-auto" showModal={showDelete} 
    HandleModelByProps={HandleModelByProps}>
      <DeleteConfirmation  onCancel={()=> HandleModelByProps(false)} onDelete={()=> HandleDelete(deleteId)}/>
    </ModelWrapper>
    }
</div>  
</ContentWithSpinner>
);
};
